import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { Toaster } from 'sonner';
import Router from '@/router/index';
import { refreshTokens } from '@/api/client';
import { useAuthStore } from '@/store/auth.store';
import '@/index.css';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});

// Bootstrap: attempt silent token refresh before rendering protected routes
async function bootstrap() {
  const { setInitialized } = useAuthStore.getState();
  try {
    await refreshTokens();
  } catch {
    // No stored token or refresh failed — user stays unauthenticated
  } finally {
    setInitialized();
  }
}

bootstrap().then(() => {
  ReactDOM.createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
      <QueryClientProvider client={queryClient}>
        <BrowserRouter>
          <Router />
          <Toaster
            position="top-right"
            toastOptions={{
              style: {
                background: '#111E30',
                border: '1px solid #1E2E42',
                color: '#F8FAFC',
              },
            }}
          />
        </BrowserRouter>
      </QueryClientProvider>
    </React.StrictMode>,
  );
});
